export default __webpack_public_path__ + "static/media/reference-mn.2a1a19d0.svg";